import { render, staticRenderFns } from "./RelatorioReceita.vue?vue&type=template&id=1a3bcb66&"
import script from "./RelatorioReceita.vue?vue&type=script&lang=js&"
export * from "./RelatorioReceita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports